<template>
  <div class="emptyContent" >
      <div class="centerWrap" >
        <div class="icon" >
          <img src="../assets/img/common/zan_wu_data.png">
        </div>
        <div class="text">暂无数据</div>
      </div>
  </div>
</template>

<script>
export default {
  name: "Empty",
  mounted() {

  }
}
</script>

<style scoped>
    .emptyContent{
      background: inherit;
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 1;
    }
    .centerWrap{
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
    }
    .text{
      font-size: 16px;
      font-family: Adobe Heiti Std, Adobe Heiti Std-R;
      font-weight: normal;
      text-align: left;
      color: #7a7a7a;
    }
    .icon{
      width: 38px;
      height: 38px;
      margin-bottom: 12px;
    }
    .icon img{
      width: 100%;
      height: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/common/Empty.vue